import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-background-dark flex items-center justify-center">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center">
          <h1 className="text-9xl font-bold text-primary-600 dark:text-primary-400 mb-4">
            404
          </h1>
          <h2 className="text-3xl font-bold text-neutral-900 dark:text-neutral-100 mb-4">
            Seite nicht gefunden
          </h2>
          <p className="text-lg text-neutral-600 dark:text-neutral-400 mb-8">
            Die von Ihnen gesuchte Seite existiert leider nicht oder wurde verschoben.
          </p>
          
          <div className="flex gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center bg-primary-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-700 transition-colors"
            >
              <HomeIcon className="w-5 h-5 mr-2" />
              Zur Startseite
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center bg-neutral-200 dark:bg-neutral-700 text-neutral-700 dark:text-neutral-200 px-6 py-3 rounded-lg font-semibold hover:bg-neutral-300 dark:hover:bg-neutral-600 transition-colors"
            >
              <ArrowLeftIcon className="w-5 h-5 mr-2" />
              Zurück
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;